module.exports = __webpack_public_path__ + "media/images/city/032-alhambra-363861efdbb28d15d9a67bf52b33fe7d.svg";